import styled from 'styled-components'
export default styled.div`
  text-align: center;
  white-space: nowrap;
  background-color: ${props => props.theme[props.backgroundColor] || props.backgroundColor};
  &:before {
    content: '';
    display: inline-block;
    vertical-align: middle;
    width: 0;
    height: ${props => props.height || '100vh'};
  }
`



// WEBPACK FOOTER //
// ./src/components/HorizontalCentered.js